module.exports = __webpack_public_path__ + "img/retrieval-min.6340a892.jpg";